import { createContext } from 'react';

import { UserContextInterface } from './types';

export const UserContext = createContext({} as UserContextInterface);
